module.exports = __webpack_public_path__ + "static/media/settings-icon.635d5460.svg";